import React from 'react'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { setPageTitle } from '../redux/slice/pageTitleSlice'
import { Form, Formik } from 'formik'
import {
  _orderStatus_,
  isInventoryModel,
  isSellerPanel
} from '../../lib/AllStaticVariables'
import SellerChart from './SellerChart'
import BrandChart from './BrandChart'
import ProductChart from './ProductChart'
import OrderChart from './OrderChart'
import TopSellingProducts from './TopSellingProducts'
import TopSellingBrand from './TopSellingBrand'
import TopUsedCoupons from './TopUsedCoupons'
import TopSellingSellers from './TopSellingSellers'

const Dashboard = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setPageTitle('Dashboard'))
  }, [])

  return (
    <Formik
      initialValues={{
        seller: 'All',
        kyc: 'All',
        brands: 'All',
        product: 'All',
        order: 'All',
        orderChart: 'All',
        topSellingProducts: 'All',
        topSellingSeller: 'All',
        topSellingBrand: 'All',
        topUsedCoupons: 'All',
        activeTab: 'Sellers'
      }}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <div className='pv-dashbord-main gy-4'>
            {!isSellerPanel && !isInventoryModel && (
              <SellerChart values={values} setFieldValue={setFieldValue} />
            )}
            <BrandChart values={values} setFieldValue={setFieldValue} />
            <ProductChart values={values} setFieldValue={setFieldValue} />
            <OrderChart values={values} setFieldValue={setFieldValue} />
            {!isSellerPanel && !isInventoryModel && (
              <TopSellingSellers
                values={values}
                setFieldValue={setFieldValue}
              />
            )}
            <TopSellingProducts values={values} setFieldValue={setFieldValue} />
            <TopSellingBrand values={values} setFieldValue={setFieldValue} />
            <TopUsedCoupons values={values} setFieldValue={setFieldValue} />
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default Dashboard
